import { Component, EventEmitter, input, OnInit, output } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { StructureProgammatiqueService } from '../../../services/structureProgrammatiquesService';
import { StructureProgrammatiqueResponse } from '../../../data/http/responses/structureprogrammatique.res';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TypeActiviteResponse } from '../../../data/http/responses/typeactivite.response';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { routeAlias } from '../../../../routesalias';
import { TypeActiviteService } from '../../../services/typeactivites/typeactivite.service';
import { AppService } from '../../../core/app.service';
import { SelectComponent } from '../../forms/select/select.component';
import { SelectOption } from '../../../data/schemas/selectoption.schema';
import { Input } from "../../forms/input/input";
import { TypeInterventionService } from '../../../services/typeintervention/typeintervention.service';
import { TypeInterventionResponse } from '../../../data/http/responses/typeintervention.response';
//import { CommonModule, DatePipe } from '@angular/common';
import { formatDate } from '@angular/common';
import { UiButtonComponent } from '../../button/button.component';
@Component({
  selector: 'app-steponeactivities',
  imports: [MatIcon, ReactiveFormsModule, SelectComponent, Input, UiButtonComponent, RouterLink],
  templateUrl: './steponeactivities.component.html',
  styleUrl: './steponeactivities.component.css'
})
export class SteponeactivitiesComponent implements OnInit {

  // Flag to show a top-right validation alert when submit fails
  showValidationAlert: boolean = false;
  missingFields: string[] = [];

  generalesData = input<any>();
  generalesChanges = output<any>();
  typeActivityChanged = output<boolean>();

  public typeInterventionData: TypeInterventionResponse[] = []
  public typeactivities: TypeActiviteResponse[] = [];
  public structures: StructureProgrammatiqueResponse[] = [];
  public resultatStructures: SelectOption[] = [];
  public types: SelectOption[] = [];
  public generaleForm: FormGroup = new FormGroup({});

  public programme: StructureProgrammatiqueResponse | null = null;
  public objectif: StructureProgrammatiqueResponse | null = null;
  public taches: any[] | null = null; // Gardez cette propriété pour afficher les tâches initiales

  public loadingTypes = false;
  public loadingStructures = false;


  private subscription: Subscription = new Subscription()

  constructor(
    private structureProgrammatiqueService: StructureProgammatiqueService,
    private typeActiviteService: TypeActiviteService,
    private typeInterventionService: TypeInterventionService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService
  ) {
    this.generaleForm = this.fb.group({
      typeCodeSelect: ['', Validators.required],
      typeInterventionSelect: ['', Validators.required],
      //typeActivitySelect: ['', Validators.required],
      activities: ['', Validators.required],
      description: [''],
      dateDebut: ['', Validators.required],
      dateFin: ['', Validators.required],
      taches: this.fb.array([])
    });
  }

  // Getter pour le FormArray des tâches
  get tachesFormArray(): FormArray {
    return this.generaleForm.get('taches') as FormArray;
  }

  // Méthode pour obtenir le label du type sélectionné
  getTypeLabel(): string {
    const selectedValue = this.generaleForm.get('typeCodeSelect')?.value;
    if (selectedValue) {
      const selectedType = this.types.find(t => t.value === selectedValue);
      return selectedType?.label || 'Parent';
    }
    return 'Parent';
  }

  // Fonction utilitaire pour aplatir la structure hiérarchique et ajouter l'ID du parent
  private flattenStructures(structures: StructureProgrammatiqueResponse[], parentId: string | null = null): StructureProgrammatiqueResponse[] {
    let flattened: StructureProgrammatiqueResponse[] = [];
    for (const structure of structures) {
      // Créer un nouvel objet pour éviter de modifier la structure originale si elle est immuable
      const currentStructure: StructureProgrammatiqueResponse = { ...structure, parent: parentId };
      flattened.push(currentStructure);
      if (structure.enfant && structure.enfant.length > 0) {
        flattened = flattened.concat(this.flattenStructures(structure.enfant, structure.id));
      }
    }
    return flattened;
  }

  loadStructures(): void {
    this.loadingStructures = true;
    this.structureProgrammatiqueService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        // Supposons que response.data est un tableau de structures de niveau supérieur avec des 'enfant' imbriqués
        this.structures = this.flattenStructures(response.data); // Aplatir et ajouter les ID des parents
        /*this.loadTypeIntervention();
       this.translateToTypeActivite();

       // Après le chargement des structures, vérifier si nous avons une valeur dans le formulaire
       const typeInterventionSelectValue = this.generaleForm.get('typeInterventionSelect')?.value;
       if (typeInterventionSelectValue) {
         this.findHierarchy(typeInterventionSelectValue);
       } */
      this.loadingStructures = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
        this.loadingStructures = false;

      }
    });
  }

  loadTypeActivite(): void {
    this.typeActiviteService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.typeactivities = response.data;

        // Après le chargement des types d'activités, vérifier si nous avons une valeur dans le formulaire
        const typeActivitySelect = this.generaleForm.get('typeActivitySelect')?.value;
        if (typeActivitySelect) {
          this.findTaches(typeActivitySelect);
        }
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  loadTypeIntervention(): void {
    this.loadingTypes = true;
    this.typeInterventionService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.typeInterventionData = response.data;
        this.types = this.typeInterventionData.map((item: TypeInterventionResponse) => ({
          value: item.id,
          label: item.libelle
        }));
        this.loadingTypes = false;

        //this.setLowestLevelTypeIntervention();
      },
      error: (error) => {
        console.error('Erreur lors du chargement des types intervention :', error);
        this.loadingTypes = false;
      }
    });
  }

  ngOnInit(): void {
    // Initialiser le formulaire avec les données reçues
    this.loadStructures();
    this.loadTypeActivite();
    this.loadTypeIntervention();

    if (this.generalesData()) {
      this.generaleForm.patchValue(this.generalesData());
      // Si les données contiennent des tâches avec chronogrammes, les patcher
      if (this.generalesData().taches && Array.isArray(this.generalesData().taches)) {
        // Vider le FormArray existant avant de le remplir pour éviter les doublons
        while (this.tachesFormArray.length !== 0) {
          this.tachesFormArray.removeAt(0);
        }
        this.generalesData().taches.forEach((task: any) => {
          const chronogrammeControls = task.chronogrammes.map((monthValue: boolean) => new FormControl(monthValue));
          this.tachesFormArray.push(this.fb.group({
            titreTache: [task.titreTache],
            chronogrammes: this.fb.array(chronogrammeControls)
          }));
        });
      }
    }

    // Supprimez l'appel à addChronogrammeCheckboxes() car les chronogrammes sont maintenant gérés par tâche
    // this.addChronogrammeCheckboxes();


    // Utiliser .add() pour gérer plusieurs souscriptions avec un seul objet Subscription
    this.subscription.add(
      this.generaleForm.get('typeCodeSelect')?.valueChanges.subscribe(selectedId => {
        if (selectedId) {
          this.translateToTypeActivite(selectedId);

          // Après le chargement des structures, vérifier si nous avons une valeur dans le formulaire
          const typeInterventionSelectValue = null;

          this.programme = null;
          this.objectif = null;
        }
      })
    );

    this.subscription.add(
      this.generaleForm.get('typeInterventionSelect')?.valueChanges.subscribe(selectedId => {
        if (selectedId) {
          this.findHierarchy(selectedId);
        } else {
          this.programme = null;
          this.objectif = null;
        }
      })
    );

    this.subscription.add(
      this.generaleForm.get('typeActivitySelect')?.valueChanges.subscribe(selectedId => {
        if (selectedId) {
          this.findTaches(selectedId);
          this.typeActivityChanged.emit(selectedId === 'Nouvelle activité');
        } else {
          this.taches = null;
          this.tachesFormArray.clear(); // Vider le FormArray des tâches si aucune activité n'est sélectionnée
          this.typeActivityChanged.emit(false);
        }
      })
    );

    // Hide validation alert when form becomes valid
    this.subscription.add(
      this.generaleForm.statusChanges.subscribe(status => {
        if (status === 'VALID') {
          this.showValidationAlert = false;
          this.missingFields = [];
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  translateToResult(): void {

    this.resultatStructures = this.structures.filter(structure => structure.typeActivite === "RESULTATS" || structure.typeActivite === "RESULTAT").map((item: any) => ({

      value: item.id,
      label: item.titre
    }));

  }

  translateToTypeActivite(type: any): void {

    //console.log("Type sélectionné :" + type);

    this.resultatStructures = this.structures.filter(structure => structure.typeActivite === type).map((item: any) => ({

      value: item.id,
      label: item.titre
    }));
    //console.log("Activités foltré :" + this.resultatStructures);

  }

  findHierarchy(selectedId: string): void {
    // Trouver le RESULTAT sélectionné dans la liste aplatie
    const selectedResultat = this.structures.find(structure => structure.id === selectedId);

    this.programme = null;
    this.objectif = null;

    //console.log("Élément sélectionné pour la hiérarchie :" + JSON.stringify(selectedResultat));

    if (selectedResultat) {
      // Trouver l'OBJECTIF parent en utilisant la propriété 'parent'
      const parentObjectif = this.structures.find(structure => structure.id === selectedResultat.parent);

      if (parentObjectif) {
        this.objectif = parentObjectif;

        // Trouver le PROGRAMME parent en utilisant la propriété 'parent' de l'OBJECTIF
        const parentProgramme = this.structures.find(structure => structure.id === parentObjectif.parent);

        if (parentProgramme) {
          this.programme = parentProgramme;
        }
      }
    } else {
      // Si l'ID sélectionné n'est pas un RESULTAT ou n'est pas trouvé, effacer la hiérarchie
      this.programme = null;
      this.objectif = null;
      console.warn('Élément sélectionné non trouvé ou n\'est pas un RESULTAT.');
    }
  }

  findTaches(selectedTypeActivity: string): void {
    const foundTypeActivity = this.typeactivities.find(typeActivity => typeActivity.type_activite === selectedTypeActivity);
    this.tachesFormArray.clear(); // Vider le FormArray avant de le remplir

    if (foundTypeActivity && foundTypeActivity.taches) {
      this.taches = foundTypeActivity.taches; // Gardez cette propriété pour l'affichage initial
      foundTypeActivity.taches.forEach(tache => {
        const chronogrammeControls = [];
        for (let i = 0; i < 12; i++) {
          chronogrammeControls.push(this.fb.control(false)); // Initialise tous les mois à false
        }
        this.tachesFormArray.push(this.fb.group({
          titreTache: [tache.tache], // Le titre de la tâche
          poids: [tache.poids],
          chronogrammes: this.fb.array(chronogrammeControls) // Le FormArray pour les chronogrammes de cette tâche
        }));
      });
    } else {
      this.taches = null;
    }
  }

  onSubmitToLocalStorage(): void {
    // //console.log(this.generaleForm.value)
    //console.log("validiter du formm :" + this.generaleForm.valid)
    if (this.generaleForm.valid) {
      const generalesFormValue = this.generaleForm.value;

      // Les tâches avec leurs chronogrammes sont déjà dans generalesFormValue.taches
      const formattedTaches = generalesFormValue.taches;

      // Créez l'objet activity avec la structure souhaitée, en imbriquant tout dans 'generales'

      const selectedTypeValue = this.generaleForm.get('typeCodeSelect')?.value;
      const t = this.typeInterventionData.find(ti => ti.id === selectedTypeValue);
      //console.log("Type intervention trouvé :", t)
      const type = this.typeInterventionData.find(ti => ti.niveau ===
        t!.niveau + 1)

      //console.log("Type intervention de niveau supérieur :", type)

      const activityData = {
        generales: {
          ...generalesFormValue,
          // Le chronogramme global n'existe plus, il est maintenant par tâche
          // chronogramme: undefined, // Cette ligne n'est plus nécessaire
          dateDebut: formatDate(
            this.generaleForm.value.dateDebut,
            'yyyy-MM-ddTHH:mm:ss', 'en-US'
          ),
          dateFin: formatDate(
            this.generaleForm.value.dateFin,
            'yyyy-MM-ddTHH:mm:ss', 'en-US'
          ),

          programme: this.programme ? { id: this.programme.id, titre: this.programme.titre } : null,
          objectif: this.objectif ? { id: this.objectif.id, titre: this.objectif.titre } : null,
          type: type?.id || null,
          // Les tâches sont déjà incluses dans generalesFormValue.taches
        },
      };

      // //console.log("activite ennnn : ",activityData)

      localStorage.setItem('activity', JSON.stringify(activityData));

      this.generalesChanges.emit({
        ...this.generaleForm.value, dateDebut: formatDate(
          this.generaleForm.value.dateDebut,
          'yyyy-MM-ddTHH:mm:ss', 'en-US'
        ),
        dateFin: formatDate(
          this.generaleForm.value.dateFin,
          'yyyy-MM-ddTHH:mm:ss', 'en-US'
        ),
        type: type?.id || null
      });

      // Naviguer vers l'étape suivante
      //this.router.navigate([], { queryParams: { step: 'activites' } });
    } else {
      this.generaleForm.markAllAsTouched(); // Afficher les erreurs de validation
      this.missingFields = this.getMissingRequiredFields();
      this.showValidationAlert = true;
      console.warn('Formulaire invalide. Veuillez remplir tous les champs requis.', this.missingFields);
    }
  }

  // Retourne la liste des champs requis manquants (labels utilisateur)
  private getMissingRequiredFields(): string[] {
    const missing: string[] = [];
    const controlsMap: { [key: string]: string } = {
      typeCodeSelect: 'Type',
      typeInterventionSelect: this.getTypeLabel(),
      activities: 'Activités',
      dateDebut: 'Date de début',
      dateFin: 'Date de fin'
    };

    Object.keys(controlsMap).forEach(key => {
      const ctrl = this.generaleForm.get(key);
      if (ctrl && ctrl.invalid) {
        missing.push(controlsMap[key]);
      }
    });

    return missing;
  }
}